// Moments from the server (created_at, opened_at, …) are stored in UTC and arrive without a zone mark.
// Reading them as local time showed a 01:03 check-in on the 13th as "12 Oct". Parse them as UTC; the browser then
// shows the hotel's local date and time. A plain date ("2026-10-13") is a calendar day, not a moment: it is kept as is.

const HAS_ZONE = /[zZ]$|[+-]\d\d:?\d\d$/;

export function parseServerDate(value?: string | null): Date | null {
  if (!value) return null;
  const text = String(value).trim();
  const hasTime = text.includes("T") || /^\d{4}-\d\d-\d\d \d/.test(text);
  if (!hasTime) {
    const day = new Date(`${text.slice(0, 10)}T00:00:00`);
    return Number.isNaN(day.getTime()) ? null : day;
  }
  const iso = text.replace(" ", "T");
  const moment = new Date(HAS_ZONE.test(iso) ? iso : `${iso}Z`);
  return Number.isNaN(moment.getTime()) ? null : moment;
}

/** "13 Oct 2026" */
export function formatServerDay(value?: string | null): string {
  const date = parseServerDate(value);
  return date ? date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "-";
}

/** "13 Oct 2026, 01:03" */
export function formatServerMoment(value?: string | null, timeZone?: string): string {
  const date = parseServerDate(value);
  if (!date) return "-";
  return `${date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone })}, ${date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone })}`;
}

/** "01:03" */
export function formatServerTime(value?: string | null): string {
  const date = parseServerDate(value);
  return date ? date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "-";
}
